import * as models from './projectsModels';
// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.
// Use @typeName and isActionType for type detection that works even after serialization/deserialization.

interface SetProjects { type: 'SET_PROJECTS'; data: models.ProjectObject[]; }
interface SetLoading { type: 'SET_LOADING_PROJECT'; data: boolean; }

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownAction =
SetProjects | SetLoading
    ;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const projectsActionCreators = {
    setProjects: (data: models.ProjectObject[]) => <SetProjects> { type: 'SET_PROJECTS', data: data },
    setLoading: (data: boolean) => <SetLoading> { type: 'SET_LOADING_PROJECT', data: data } 

};


// WEBPACK FOOTER //
// ./src/data/projects/projectsAction.ts